module.exports = __webpack_public_path__ + "static/media/14UNEP13.09dd3679.jpg";